export default __webpack_public_path__ + "static/media/rayen.f08e07ad.png";